import { createSlice, isPending } from '@reduxjs/toolkit';
import {
  loginUser,
  registerUser,
  updateUserDetails,
  switchTwoFactorAuth,
  updateUserPassword,
} from './authActions';

const userToken = localStorage.getItem('userToken')
  ? localStorage.getItem('userToken')
  : null;

const userInfo = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo') || '')
  : null;

export interface IUser {
  id: number;
  email: string;
  name: string;
  surname: string;
  phone_number: string;
  zip_code: string | null;
  city: string | null;
  photo_url: string | null;
  state: string | null;
  rating: string;
  is_verified: boolean;
  two_factor_auth: boolean;
  created_at: Date;
  updated_at: Date;
  password_updated_at: Date;
}

interface IAuthState {
  user: IUser | null;
  error: string | null;
  token: string | null;
  isLoading: boolean;
  success: boolean;
  updated: boolean;
}

const initialState: IAuthState = {
  user: userInfo,
  error: null,
  token: userToken,
  isLoading: false,
  success: false,
  updated: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      localStorage.removeItem('userToken'); // deletes token from storage
      localStorage.removeItem('userInfo'); // deletes token from storage
      state.user = null;
      state.token = null;
      state.isLoading = false;
    },
    resetErrorsAndSuccess(state) {
      state.error = null;
      state.success = false;
      state.isLoading = false;
      state.updated = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.data.user;
        state.token = action.payload.data.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.data.user;
        state.token = action.payload.data.token;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || null;
      })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updated = true;
        state.user = action.payload.data;
      })
      .addCase(updateUserDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.updated = false;
        state.error = action.payload || null;
      })
      .addCase(switchTwoFactorAuth.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.data;
      })
      .addCase(switchTwoFactorAuth.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || null;
      })
      .addCase(updateUserPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(updateUserPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || null;
      })
      .addMatcher(
        isPending(
          loginUser,
          registerUser,
          updateUserDetails,
          switchTwoFactorAuth,
          updateUserPassword
        ),
        (state) => {
          state.isLoading = true;
          state.error = null;
          state.success = false;
          state.updated = false;
        }
      );
  },
});
// export actions
export const { logout, resetErrorsAndSuccess } = authSlice.actions;
export default authSlice.reducer;
